export default "__VITE_ASSET__7440bfc6__"